import { render } from "./LastLeadCreatedInterval.vue?vue&type=template&id=5326930e&scoped=true"
import script from "./LastLeadCreatedInterval.vue?vue&type=script&lang=js"
export * from "./LastLeadCreatedInterval.vue?vue&type=script&lang=js"

import "./LastLeadCreatedInterval.vue?vue&type=style&index=0&id=5326930e&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5326930e"]])

export default __exports__